import React from "../../__snowpack__/pkg/react.js";
export function IconFaq() {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, /* @__PURE__ */ React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /* @__PURE__ */ React.createElement("g", {
    fillRule: "nonzero"
  }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
    fill: "#20A0FF",
    d: "M8 0C3.6 0 0 3.6 0 8v8h8c4.4 0 8-3.6 8-8s-3.6-8-8-8z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#FFF",
    d: "M12 12.3l-.918-1.611a3.948 3.948 0 00.704-1.578 3.954 3.954 0 00-.022-1.734 3.928 3.928 0 00-1.76-2.475 3.813 3.813 0 00-2.969-.49c-.52.122-.993.341-1.418.657-.414.305-.757.68-1.028 1.126a4.073 4.073 0 00-.533 1.427 4.045 4.045 0 00.049 1.584 4 4 0 00.654 1.438 3.913 3.913 0 002.518 1.584c.52.089 1.041.072 1.562-.05.242-.06.476-.142.703-.246.228-.1.444-.223.65-.368l.417.736H12zm-3.447-1.36a2.57 2.57 0 01-2.029-.335 2.65 2.65 0 01-1.198-1.69 2.652 2.652 0 01.33-2.05A2.594 2.594 0 017.32 5.642a2.554 2.554 0 012.024.335c.63.397 1.03.96 1.198 1.689.07.301.09.602.06.903a2.69 2.69 0 01-.236.87l-.726-1.271H8.256l1.303 2.291c-.15.112-.31.208-.478.29a2.633 2.633 0 01-.528.19z"
  })))));
}
